import React from 'react';
import { FormattedMessage } from 'react-intl';
import { SHORT_PLAIN_TEXT_LENGTH } from '../../constants/common.constants';
import { MAX_LENGTH_NOT_REQUIRED_ERROR_MESSAGE } from '../../constants/validation-errors';

export function checkForShourtPlainText(fieldName: string, message: string, isMandatory: boolean): string | JSX.Element {
    if (message.length > SHORT_PLAIN_TEXT_LENGTH) {
        return MAX_LENGTH_NOT_REQUIRED_ERROR_MESSAGE;
    } else if (isMandatory && !message) {
        return <FormattedMessage
            description='Warning message'
            defaultMessage='{field} is required'
            id='oe.common.fieldIsRequired'
            values={{
                field: fieldName
            }}
        />;
    } else {
        return '';
    }
};